/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useState } from 'react';
import useHandleInvitation from '../../redux/features/user/handleInvitation/useHandleInvitation';

export const notificationActions = {
  ACCEPT_INVITATION: 'ACCEPT_INVITATION',
  DECLINE_INVITATION: 'DECLINE_INVITATION',
};

export default function useNotificationMenu(userId) {
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    onAcceptInvitation,
    onDeclineInvitation,
    onToggleDialog,
    onSubmit,
    onAcceptedInvitationConfirm,
    dialog,
    invitation,
    invitationStatus,
  } = useHandleInvitation(userId);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const executeNotificationAction = (notification, action) => {
    switch (action) {
      case notificationActions.ACCEPT_INVITATION: {
        handleClose();
        onAcceptInvitation(notification);
        break;
      }

      case notificationActions.DECLINE_INVITATION: {
        onDeclineInvitation(notification.id);
        break;
      }

      default: {
        // to be handled
        break;
      }
    }
  };

  return {
    anchorEl,
    dialog,
    invitation,
    invitationStatus,
    onSubmit,
    onToggleDialog,
    onAcceptedInvitationConfirm,
    handleClose,
    handleClick,
    executeNotificationAction,
  };
}
